import { render } from "./UserPassList.vue?vue&type=template&id=4950ea69&scoped=true"
import script from "./UserPassList.vue?vue&type=script&lang=js"
export * from "./UserPassList.vue?vue&type=script&lang=js"

import "./UserPassList.vue?vue&type=style&index=0&id=4950ea69&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4950ea69"]])

export default __exports__